import { useTranslation } from 'react-i18next';
import { BodyText } from 'vopay';
import { useAlertDialog } from 'shared';

export default function useDeleteIpAddressDialog() {
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.AuthorizedIpsSettings.DeleteDialog' });
  const alertDialog = useAlertDialog();

  return async function confirmDeleteIp(ip: string, isLastIp: boolean): Promise<boolean> {
    const result = await alertDialog.caution(
      t('title', { defaultValue: 'Remove {{ip}}?', ip }),
      <BodyText>
        {isLastIp
          ? t('lastIpBody', {
              defaultValue: 'Removing your last address will allow API requests from any IP address.',
            })
          : t('body', { defaultValue: 'API requests from this address will be rejected' })}
      </BodyText>,
      {
        abortLabel: t('cancelButton', { defaultValue: 'Cancel' }),
        confirmLabel: isLastIp
          ? t('allowAllButton', { defaultValue: 'Allow all IP addresses' })
          : t('removeButton', { defaultValue: 'Remove' }),
      },
    );

    return result === 'confirm';
  };
}
